import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import CheckBox from 'components/form/CheckBox'
import { applyPreset } from 'features/dashboard/table/config/tableConfigSlice'
import { getSerializablePreset } from 'features/dashboard/table/shared/Presets'
import { useDashboardTypeName } from 'features/dashboard/utils/hooks/useDashboardTypeName'

export const PresetListItem = ({ preset }) => {
  const dispatch = useDispatch()
  const { name: tabName, type: domainType } = useDashboardTypeName()
  const appliedColumnPresets = useSelector(
    ({ dashboard }) => dashboard.table.config.appliedColumnPresets[domainType]
  )
  return (
    <li className={classNames({ on: appliedColumnPresets[preset.name] })}>
      <CheckBox
        {...(preset.tiaraActionName && {
          tiaraAction: `${tabName}탭_${preset.tiaraActionName}`,
        })}
        label={preset.displayName}
        checked={!!appliedColumnPresets[preset.name]}
        onCheckedChange={isChecked =>
          dispatch(
            applyPreset({
              preset: getSerializablePreset(preset),
              isChecked,
              domainType,
            })
          )
        }
      />
    </li>
  )
}

PresetListItem.propTypes = {
  preset: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    tiaraActionName: PropTypes.string,
  }),
}
